var _defs, _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.96 24.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fff;}.cls-3{fill:url(#Unbenannter_Verlauf_3);}.cls-4{fill:url(#Unbenannter_Verlauf_2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_3",
    cx: -143.41,
    cy: -595.88,
    r: 0.08,
    gradientTransform: "translate(9708.54 45509.01) scale(67.64 76.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffc800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ff9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_2",
    cx: -138.55,
    cy: -595.9,
    r: 0.09,
    gradientTransform: "translate(7000.04 45562.98) scale(50.49 76.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00b0e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#01a5db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0292cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0377ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0455a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054696"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.7,
    width: 39.56,
    height: 22.95,
    rx: 2.83
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.85,0H37.11A3.86,3.86,0,0,1,41,3.85V20.6a3.86,3.86,0,0,1-3.85,3.85H3.85A3.86,3.86,0,0,1,0,20.6V3.85A3.86,3.86,0,0,1,3.85,0ZM37.11,1.33H3.85A2.53,2.53,0,0,0,1.33,3.85V20.6a2.54,2.54,0,0,0,2.52,2.53H37.11a2.54,2.54,0,0,0,2.52-2.53V3.85a2.53,2.53,0,0,0-2.52-2.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M13.3,14.82a.5.5,0,0,1-.23.38L8.74,17.7a.51.51,0,0,1-.45,0L4,15.2a.49.49,0,0,1-.23-.38v-5A.47.47,0,0,1,4,9.43L8.29,6.92a.58.58,0,0,1,.45,0l4.33,2.51a.5.5,0,0,1,.23.38Zm24-4.65H33.45v.92h1.39v4h1.09v-4h1.39Zm-17.6,0H15.84v.92h1.39v4h1.09v-4h1.39ZM30.93,10a1.76,1.76,0,0,0-1.9,1.9v3.14h1.09V11.9a.8.8,0,0,1,.82-.87.83.83,0,0,1,.82.87v3.16h1.08V11.92A1.76,1.76,0,0,0,30.93,10Zm-4.09.15v4.88h1.08V10.17Zm-3.68,1.94,0,.22,1,2.73h.44l1.39-4.88H25l-.66,2.56,0,.28-.06-.28-.88-2.56H23l-.88,2.56-.05.28,0-.28-.66-2.56H20.28l1.38,4.88h.45l1-2.73,0-.22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-3",
    d: "M10.78,12.33,9.65,14l-.58-.89.67-1a1.33,1.33,0,0,0,.08-1.33,1.39,1.39,0,0,0-2.52,0,1.27,1.27,0,0,0,.08,1.31l.68,1,.5.73L9.31,15a.48.48,0,0,0,.34.19A.5.5,0,0,0,10,15l1.77-2.62h-1Zm-2.23,0-.49-.76a.56.56,0,1,1,1,0C8.85,11.92,8.55,12.37,8.55,12.37Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.47,13.93,6.36,12.37l-.49-.76a.56.56,0,0,1,.49-.83.5.5,0,0,1,.17,0l.38-.72A1.5,1.5,0,0,0,6.36,10a1.39,1.39,0,0,0-1.26.8,1.27,1.27,0,0,0,.08,1.31L7.12,15a.47.47,0,0,0,.34.2A.42.42,0,0,0,7.8,15l.59-.9-.5-.73-.42.59Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwint);
export default __webpack_public_path__ + "static/media/twint.0624044857e60ba764287ae9c891d733.svg";
export { ForwardRef as ReactComponent };